(() => {
const norm = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
let serial = 0;
function init() {
 const template = document.getElementById('mood-category-search-template');
 if (!template) return;
 document.querySelectorAll('[data-mood-subcategories]').forEach(group => {
  if(group.querySelector('.mc-search')) return;
  const seen = new Set();
  const entries = Array.from(group.querySelectorAll('a[href]')).flatMap(a => {
   const u = new URL(a.href,location.href);
   if(u.origin!==location.origin || !u.pathname.includes('/collections/') || seen.has(u.pathname)) return [];
   seen.add(u.pathname);
   const title = a.textContent.replace(/\s*→\s*$/,'').trim();
   return [{title,href:u.pathname+u.search,key:norm(title+' '+u.pathname.split('/').pop())}];
  });
  if(!entries.length) return;
  const frag=template.content.cloneNode(true), box=frag.querySelector('.mc-search'), input=box.querySelector('input'), results=box.querySelector('.mc-results'), status=box.querySelector('[role=status]');
  input.id='mc-search-'+(++serial);
  box.querySelector('label').htmlFor=input.id;
  results.id=input.id+'-results';
  input.setAttribute('aria-controls',results.id);
  const close=()=>{results.hidden=true;};
  const render=()=>{
   results.replaceChildren();
   const q=norm(input.value);
   if(!q){close();status.textContent='';return;}
   const matches=entries.filter(e=>q.split(' ').every(w=>e.key.includes(w)));
   results.hidden=false;
   status.textContent=matches.length?box.dataset.count.replace('[count]',matches.length):box.dataset.empty;
   if(!matches.length){const p=document.createElement('p');p.textContent=box.dataset.empty;results.append(p);return;}
   const ul=document.createElement('ul');
   matches.forEach(e=>{const li=document.createElement('li'),a=document.createElement('a');a.href=e.href;a.textContent=e.title+' →';li.append(a);ul.append(li);});
   results.append(ul);
  };
  input.addEventListener('input',render);
  input.addEventListener('focus',render);
  input.addEventListener('keydown',e=>{
   if(e.key==='Escape')close();
   if(e.key==='ArrowDown'){if(results.hidden)render();const a=results.querySelector('a');if(a){e.preventDefault();a.focus();}}
   if(e.key==='Enter'&&!results.hidden){const a=results.querySelector('a');if(a){e.preventDefault();a.click();}}
  });
  results.addEventListener('keydown',e=>{
   if(e.key==='Escape'){input.focus();close();}
   if(e.key==='ArrowDown'||e.key==='ArrowUp'){
    e.preventDefault();const links=Array.from(results.querySelectorAll('a')),i=links.indexOf(document.activeElement)+(e.key==='ArrowDown'?1:-1);
    if(i<0)input.focus();else links[Math.min(i,links.length-1)]?.focus();
   }
  });
  box.addEventListener('focusout',e=>{if(!box.contains(e.relatedTarget))close();});
  document.addEventListener('pointerdown',e=>{if(!box.contains(e.target))close();});
  group.prepend(frag);
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();